import { createSlice } from "@reduxjs/toolkit";
import {
    fetchSecurityRecords,
    fetchSecurityRecordById,
    createSecurityRecord,
    updateSecurityRecord,
    deleteSecurityRecord,
} from "@/apis/security/securityRulesRecordsApi";

const slice = createSlice({
    name: "securityRulesRecords",
    initialState: {
        list: [],
        listLoading: false,
        current: null,
        loading: false,
        saving: false,
        deleting: false,
    },
    reducers: {
        clearCurrentRecord(state) {
            state.current = null;
        },
    },
    extraReducers: (builder) => {
        builder
            //fetch all
            .addCase(fetchSecurityRecords.pending, (s) => {
                s.listLoading = true;
            })
            .addCase(fetchSecurityRecords.fulfilled, (s, a) => {
                s.list = a.payload;
                s.listLoading = false;
            })
            .addCase(fetchSecurityRecords.rejected, (s) => {
                s.listLoading = false;
            })
            // fetchById
            .addCase(fetchSecurityRecordById.pending, (s) => { s.loading = true })
            .addCase(fetchSecurityRecordById.fulfilled, (s, a) => { s.current = a.payload; s.loading = false })
            .addCase(fetchSecurityRecordById.rejected, (s) => { s.loading = false })

            // create
            .addCase(createSecurityRecord.pending, (s) => { s.saving = true })
            .addCase(createSecurityRecord.fulfilled, (s) => { s.saving = false })
            .addCase(createSecurityRecord.rejected, (s) => { s.saving = false })

            // update
            .addCase(updateSecurityRecord.pending, (s) => { s.saving = true })
            .addCase(updateSecurityRecord.fulfilled, (s) => { s.saving = false })
            .addCase(updateSecurityRecord.rejected, (s) => { s.saving = false })

            // delete
            .addCase(deleteSecurityRecord.pending, (s) => { s.deleting = true })
            .addCase(deleteSecurityRecord.fulfilled, (s) => { s.deleting = false })
            .addCase(deleteSecurityRecord.rejected, (s) => { s.deleting = false });
    },
});

export const { clearCurrentRecord } = slice.actions;
export default slice.reducer;
